export const translations = {
  de: {
    nav: {
      events: 'Events',
      news: 'News & Reviews',
      buddies: 'Buddies',
      profile: 'Profil',
      login: 'Login',
      logout: 'Logout'
    },
    auth: {
      title: 'Anmelden',
      username: 'Benutzername',
      email: 'E-Mail',
      password: 'Passwort',
      register: 'Registrieren',
      login: 'Einloggen',
      logout: 'Ausloggen',
      loggedIn: 'Eingeloggt als',
      notLoggedIn: 'Nicht eingeloggt',
      rolePartyBuddy: 'PartyBuddy',
      roleArtist: 'Künstler/DJ',
      roleOrganizer: 'Veranstalter/Lokal',
      registerSuccess: 'Registrierung erfolgreich!',
      registerError: 'Registrierung fehlgeschlagen',
      loginError: 'Anmeldung fehlgeschlagen',
      forgotPassword: 'Passwort vergessen?',
      resetTitle: 'Passwort zurücksetzen',
      resetInstructions: 'Gib deine E-Mail-Adresse ein, um einen Link zum Zurücksetzen deines Passworts zu erhalten.',
      resetEmailRequired: 'Bitte gib zuerst deine E-Mail ein!',
      resetButton: 'Link zum Zurücksetzen senden',
      resetSending: 'Wird gesendet...',
      resetSuccess: 'Die E-Mail zum Zurücksetzen des Passworts wurde gesendet. Bitte überprüfe dein Postfach.',
      resetInvalidEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',
      resetTooManyRequests: 'Zu viele Versuche. Bitte versuche es später erneut.',
      resetError: 'Zurücksetzen fehlgeschlagen. Bitte überprüfe deine E-Mail-Adresse und versuche es erneut.',
      backToLogin: '← Zurück zum Login',
      rememberMe: 'Angemeldet bleiben'
    },
    profile: {
      loading: 'Profil wird geladen...',
      photo: 'Profilbild',
      choosePhoto: 'Foto wählen',
      qrTitle: 'QR-Code für dieses Profil',
      qrLocked: 'QR-Code nur persönlich sichtbar',
      musicStyle: 'Lieblings-Musikstil',
      city: 'Wohnort',
      save: 'Speichern',
      saved: 'Profil erfolgreich gespeichert!',
      followers: 'Follower',
      follow: 'Folgen',
      following: 'Folge ich',
      unfollow: 'Nicht mehr folgen'
    },
    buddies: {
      title: 'Meine Buddies',
      addBuddy: 'Buddy hinzufügen',
      closeScanner: 'Scanner schließen',
      scanFail: 'Kamera-Zugriff fehlgeschlagen',
      selfAdd: 'Du kannst dich nicht selbst hinzufügen.',
      notFound: 'Kein Benutzer mit diesem QR-Code gefunden.',
      alreadyAdded: 'Dieser Buddy ist bereits hinzugefügt.',
      scanError: 'Fehler beim Verarbeiten des QR-Codes.',
      pending: 'Ausstehend',
      accepted: 'Angenommen',
      chatLocked: 'Chat ist erst nach Bestätigung verfügbar.',
      openChat: 'Chat',
      profileBtn: 'Profil',
      noBuddies: 'Keine Buddies gefunden.',
      selectBuddy: 'Buddy auswählen, um zu chatten.',
      messagePlaceholder: 'Nachricht schreiben...',
      invalidQr: 'Dieser QR-Code ist kein PartyBuddy-Buddy-Code.',
      unknownUser: 'PartyBuddy-Nutzer',
      thisIsYou: 'Das bist du',
      alreadyBuddies: 'Bereits Buddies',
      requestSentLabel: 'Anfrage gesendet',
      accept: 'Annehmen'
    },
    chat: {
      viewEvent: 'Event ansehen',
      eventLoading: 'Event wird geladen…',
      eventUnavailable: 'Dieses Event ist nicht mehr verfügbar.'
    },
    events: {
      title: 'Finde dein Event',
      city: 'Stadt',
      mood: 'Mood',
      genre: 'Genre',
      publicEvents: 'Öffentliche Events',
      buddyEvents: 'Buddy-Events',
      yourEvents: 'Deine Events',
      addEvent: 'Neues Event hinzufügen',
      closeForm: 'Formular schließen',
      public: 'Öffentlich',
      buddiesOnly: 'Nur Buddies',
      save: 'Speichern',
      update: 'Aktualisieren',
      loadError: 'Events konnten nicht geladen werden. Bitte versuche es erneut.'
    },
    event: {
      back: 'Zurück zu Events',
      loading: 'Wird geladen…',
      noImage: 'Kein Bild',
      organizer: 'Veranstalter',
      venue: 'Ort',
      city: 'Stadt',
      country: 'Land',
      date: 'Datum',
      description: 'Beschreibung',
      genres: 'Genres',
      moods: 'Moods',
      postedOn: 'Gepostet am',
      openSource: 'Quelle öffnen',
      share: 'Teilen',
      copyLink: 'Link kopieren',
      linkCopied: 'Link kopiert!',
      notFoundTitle: 'Event nicht gefunden',
      notFoundMessage: 'Dieses Event existiert nicht oder wurde entfernt.',
      unavailableTitle: 'Event nicht verfügbar',
      unavailableMessage: 'Du hast keinen Zugriff auf dieses Event.',
      adminInfo: 'Admin-Info',
      sendToBuddy: 'An Buddy senden',
      sendToBuddyTitle: 'An Buddy senden',
      close: 'Schließen',
      searchBuddies: 'Buddys suchen…',
      loadingBuddies: 'Buddys werden geladen…',
      noBuddiesToSend: 'Keine Buddys verfügbar, an die dieses Event gesendet werden kann.',
      send: 'Senden',
      sending: 'Wird gesendet…',
      sent: 'Gesendet',
      sendFailed: 'Erneut versuchen'
    },
    home: {
      title: 'Bleib auf dem Laufenden',
      publicNews: 'Öffentliche News',
      publicReviews: 'Öffentliche Reviews',
      buddyNews: 'Buddy News',
      buddyReviews: 'Buddy Reviews',
      yourNews: 'Deine News',
      yourReviews: 'Deine Reviews',
      createPost: 'Beitrag erstellen',
      createNews: 'Neue News',
      createReview: 'Neue Review',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      loadError: 'News/Reviews konnten nicht geladen werden. Bitte versuche es erneut.'
    },
    ticket: {
      add: 'Ticket-Link hinzufügen',
      locked: 'Premium-Funktion – bald verfügbar',
      buy: 'Tickets kaufen'
    },
    search: {
      placeholder: 'z.B. „Techno Graz morgen“',
      label: 'Intelligente Suche',
      clear: 'Suche löschen'
    },
    filters: {
      button: 'Filter',
      noFilters: 'Keine Filter',
      clear: 'Löschen',
      clearAll: 'Alle löschen',
      removeTag: 'Entfernen',
      city: 'Stadt',
      from: 'Von',
      to: 'Bis',
      mood: 'Stimmung',
      genre: 'Genre',
      location: 'Standort',
      radius: 'Umkreis',
      locationReady: 'Standort bereit',
      locationPending: 'Standort ausstehend',
      searchPlaceholder: 'Suchen…'
    },
    avatar: {
      customize: 'PartyBuddy-Avatar anpassen',
      hideEditor: 'Avatar-Editor ausblenden',
      usedWhenNoPhoto: 'Wird angezeigt, solange kein Foto hochgeladen ist.',
      base: 'Darstellung',
      baseFemale: 'Weiblich',
      baseMale: 'Männlich',
      skinTone: 'Hautton',
      hairStyle: 'Frisur',
      hairColor: 'Haarfarbe',
      facialHair: 'Gesichtsbehaarung',
      eyebrows: 'Augenbrauen',
      eyeStyle: 'Augenform',
      eyeColor: 'Augenfarbe',
      mouth: 'Mund',
      glasses: 'Brille'
    },
    common: {
      search: 'Suchen',
      cancel: 'Abbrechen',
      save: 'Speichern',
      error: 'Etwas ist schiefgelaufen.',
      phase: 'Aktive Phase',
      language: 'Sprache',
      retry: 'Erneut versuchen',
      loadMore: 'Mehr laden',
      loadingMore: 'Wird geladen…'
    },
    errorBoundary: {
      title: 'Etwas ist schiefgelaufen',
      message: 'Es gab ein unerwartetes Problem. Bitte lade die Seite neu.',
      reload: 'Seite neu laden',
      backToEvents: 'Zurück zu Events'
    },
    notFound: {
      heading: 'Seite nicht gefunden',
      message: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
      backHome: 'Zurück zu Events'
    }
  },
  en: {
    nav: {
      events: 'Events',
      news: 'News & Reviews',
      buddies: 'Buddies',
      profile: 'Profile',
      login: 'Login',
      logout: 'Logout'
    },
    auth: {
      title: 'Login',
      username: 'Username',
      email: 'E-mail',
      password: 'Password',
      register: 'Register',
      login: 'Log in',
      logout: 'Log out',
      loggedIn: 'Logged in as',
      notLoggedIn: 'Not logged in',
      rolePartyBuddy: 'PartyBuddy',
      roleArtist: 'Artist/DJ',
      roleOrganizer: 'Organizer/Venue',
      registerSuccess: 'Registration successful!',
      registerError: 'Registration failed',
      loginError: 'Sign-in failed',
      forgotPassword: 'Forgot password?',
      resetTitle: 'Reset password',
      resetInstructions: 'Enter your email address to receive a password reset link.',
      resetEmailRequired: 'Please enter your email first!',
      resetButton: 'Send reset link',
      resetSending: 'Sending...',
      resetSuccess: 'Password reset email sent. Please check your inbox.',
      resetInvalidEmail: 'Please enter a valid email address.',
      resetTooManyRequests: 'Too many attempts. Please try again later.',
      resetError: 'Password reset failed. Please check your email address and try again.',
      backToLogin: '← Back to login',
      rememberMe: 'Stay logged in'
    },
    profile: {
      loading: 'Loading profile...',
      photo: 'Profile picture',
      choosePhoto: 'Choose photo',
      qrTitle: 'QR code for this profile',
      qrLocked: 'QR code visible only in person',
      musicStyle: 'Favorite music style',
      city: 'City',
      save: 'Save',
      saved: 'Profile saved successfully!',
      followers: 'Followers',
      follow: 'Follow',
      following: 'Following',
      unfollow: 'Unfollow'
    },
    buddies: {
      title: 'My Buddies',
      addBuddy: 'Add buddy',
      closeScanner: 'Close scanner',
      scanFail: 'Camera access failed',
      selfAdd: 'You cannot add yourself.',
      notFound: 'No user found for this QR code.',
      alreadyAdded: 'This buddy is already added.',
      scanError: 'Error processing the QR code.',
      pending: 'Pending',
      accepted: 'Accepted',
      chatLocked: 'Chat is available after confirmation.',
      openChat: 'Chat',
      profileBtn: 'Profile',
      noBuddies: 'No buddies found yet.',
      selectBuddy: 'Select a buddy to chat.',
      messagePlaceholder: 'Write a message...',
      loadError: "Couldn't load your buddies. Please try again.",
      invalidQr: "This QR code isn't a PartyBuddy buddy code.",
      unknownUser: 'PartyBuddy user',
      thisIsYou: 'This is you',
      alreadyBuddies: 'Already buddies',
      requestSentLabel: 'Request sent',
      accept: 'Accept'
    },
    chat: {
      viewEvent: 'View Event',
      eventLoading: 'Loading event…',
      eventUnavailable: 'This event is no longer available.'
    },
    events: {
      title: 'Find your event',
      city: 'City',
      mood: 'Mood',
      genre: 'Genre',
      publicEvents: 'Public Events',
      buddyEvents: 'Buddy Events',
      yourEvents: 'Your Events',
      addEvent: 'Add new event',
      closeForm: 'Close form',
      public: 'Public',
      buddiesOnly: 'Buddies only',
      save: 'Save',
      update: 'Update',
      loadError: "Couldn't load events right now. Please try again."
    },
    event: {
      back: 'Back to Events',
      loading: 'Loading…',
      noImage: 'No image',
      organizer: 'Organizer',
      venue: 'Venue',
      city: 'City',
      country: 'Country',
      date: 'Date',
      description: 'Description',
      genres: 'Genres',
      moods: 'Moods',
      postedOn: 'Posted on',
      openSource: 'Open source',
      share: 'Share',
      copyLink: 'Copy link',
      linkCopied: 'Link copied!',
      notFoundTitle: 'Event not found',
      notFoundMessage: "This event doesn't exist or has been removed.",
      unavailableTitle: 'Event unavailable',
      unavailableMessage: "You don't have access to this event.",
      adminInfo: 'Admin info',
      sendToBuddy: 'Send to Buddy',
      sendToBuddyTitle: 'Send to Buddy',
      close: 'Close',
      searchBuddies: 'Search buddies…',
      loadingBuddies: 'Loading buddies…',
      noBuddiesToSend: 'No buddies available to send this event to.',
      send: 'Send',
      sending: 'Sending…',
      sent: 'Sent',
      sendFailed: 'Retry'
    },
    home: {
      title: 'Stay updated with the latest scene news.',
      publicNews: 'Public News',
      publicReviews: 'Public Reviews',
      buddyNews: 'Buddy News',
      buddyReviews: 'Buddy Reviews',
      yourNews: 'Your News',
      yourReviews: 'Your Reviews',
      createPost: 'Create post',
      createNews: 'New News',
      createReview: 'New Review',
      edit: 'Edit',
      delete: 'Delete',
      loadError: "Couldn't load news/reviews. Please try again."
    },
    ticket: {
      add: 'Add ticket link',
      locked: 'Premium feature – coming soon',
      buy: 'Buy tickets'
    },
    search: {
      placeholder: 'e.g. "Techno Graz tomorrow"',
      label: 'Smart search',
      clear: 'Clear search'
    },
    filters: {
      button: 'Filters',
      noFilters: 'No filters',
      clear: 'Clear',
      clearAll: 'Clear all',
      removeTag: 'Remove',
      city: 'City',
      from: 'From',
      to: 'To',
      mood: 'Mood',
      genre: 'Genre',
      location: 'Location',
      radius: 'Radius',
      locationReady: 'Location ready',
      locationPending: 'Location pending',
      searchPlaceholder: 'Search…'
    },
    avatar: {
      customize: 'Customize your PartyBuddy avatar',
      hideEditor: 'Hide avatar editor',
      usedWhenNoPhoto: 'Shown whenever you have no uploaded photo.',
      base: 'Presentation',
      baseFemale: 'Female',
      baseMale: 'Male',
      skinTone: 'Skin tone',
      hairStyle: 'Hairstyle',
      hairColor: 'Hair color',
      facialHair: 'Facial hair',
      eyebrows: 'Eyebrows',
      eyeStyle: 'Eye style',
      eyeColor: 'Eye color',
      mouth: 'Mouth',
      glasses: 'Glasses'
    },
    common: {
      search: 'Search',
      cancel: 'Cancel',
      save: 'Save',
      error: 'Something went wrong.',
      phase: 'Active phase',
      language: 'Language',
      retry: 'Retry',
      loadMore: 'Load more',
      loadingMore: 'Loading…'
    },
    errorBoundary: {
      title: 'Something went wrong',
      message: 'An unexpected problem occurred. Please reload the page.',
      reload: 'Reload',
      backToEvents: 'Back to Events'
    },
    notFound: {
      heading: 'Page not found',
      message: "The page you're looking for doesn't exist or has moved.",
      backHome: 'Back to Events'
    }
  }
};

Object.assign(translations.de.auth, {
  emailInUse: 'Diese E-Mail-Adresse wird bereits verwendet.',
  invalidEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',
  weakPassword: 'Dein Passwort ist zu schwach.',
  invalidCredentials: 'E-Mail oder Passwort sind nicht korrekt.',
  tooManyRequests: 'Zu viele Versuche. Bitte versuche es später erneut.',
  networkError: 'Netzwerkfehler. Bitte prüfe deine Verbindung und versuche es erneut.'
});
Object.assign(translations.en.auth, {
  emailInUse: 'This email address is already in use.',
  invalidEmail: 'Please enter a valid email address.',
  weakPassword: 'Your password is too weak.',
  invalidCredentials: 'Incorrect email or password.',
  tooManyRequests: 'Too many attempts. Please try again later.',
  networkError: 'Network error. Please check your connection and try again.'
});

Object.assign(translations.de.profile, {
  saveError: 'Dein Profil konnte nicht gespeichert werden. Bitte versuche es erneut.',
  photoHelp: 'JPG, PNG, WEBP oder GIF, bis zu 5 MB.',
  defaultTitle: 'Profil'
});
Object.assign(translations.en.profile, {
  saveError: 'Could not save your profile. Please try again.',
  photoHelp: 'JPG, PNG, WEBP or GIF, up to 5 MB.',
  defaultTitle: 'Profile'
});

Object.assign(translations.de.buddies, {
  scanHint: 'Halte die Kamera auf den QR-Code deines Buddys. Erlaube den Kamerazugriff, wenn du dazu aufgefordert wirst.',
  requestSent: 'Buddy-Anfrage gesendet.',
  cameraPermission: 'Kamera-Zugriff fehlgeschlagen. Bitte erlaube die Kamera-Berechtigung.',
  noCamera: 'Es konnte keine nutzbare Kamera auf diesem Gerät gestartet werden.',
  accept: 'Annehmen',
  chatWith: 'Chat mit',
  loadError: 'Deine Buddies konnten nicht geladen werden. Bitte versuche es erneut.',
  invalidQr: 'Dieser QR-Code gehört nicht zu PartyBuddy.',
  buddyRecognized: 'Buddy erkannt',
  loadingBuddies: 'Buddies werden geladen…',
  loadingConversation: 'Unterhaltung wird geladen…',
  conversationLoadError: 'Unterhaltung konnte nicht geladen werden.',
  backToList: 'Zurück zur Liste'
});
Object.assign(translations.en.buddies, {
  scanHint: "Point the camera at your buddy's QR code. Allow camera access if prompted.",
  requestSent: 'Buddy request sent.',
  cameraPermission: 'Camera access failed. Please allow camera permission.',
  noCamera: 'No usable camera could be started on this device.',
  accept: 'Accept',
  chatWith: 'Chat with',
  invalidQr: "This QR code isn't a PartyBuddy buddy code.",
  buddyRecognized: 'Buddy found',
  loadingBuddies: 'Loading buddies…',
  loadingConversation: 'Loading conversation…',
  conversationLoadError: 'Could not load the conversation.',
  backToList: 'Back to list'
});


translations.de.chat = {
  ...translations.de.chat,
  title: 'Chat',
  loading: 'Chat wird geladen...',
  loadError: 'Fehler beim Laden des Chats. Bitte versuche es erneut.',
  sendError: 'Nachricht konnte nicht gesendet werden.',
  back: 'Zurück',
  chatWith: 'Chat mit',
  empty: 'Noch keine Nachrichten. Starte die Unterhaltung! 👋',
  messagePlaceholder: 'Nachricht schreiben...',
  sendTitle: 'Nachricht senden',
  eventMessageNotification: 'Dir wurde ein Event gesendet',
  newMessagePreviewFallback: 'Neue Nachricht',
  eventSharedPreview: 'Event gesendet',
  newMessagesIndicator: 'Neue Nachrichten',
  noConversationYet: 'Noch keine Unterhaltung',
  composerHint: 'Enter zum Senden, Umschalt+Enter für eine neue Zeile',
  sending: 'Wird gesendet…'
};
translations.en.chat = {
  ...translations.en.chat,
  title: 'Chat',
  loading: 'Loading chat...',
  loadError: 'Error loading chat. Please try again.',
  sendError: 'Failed to send message.',
  back: 'Back',
  chatWith: 'Chat with',
  empty: 'No messages yet. Start the conversation! 👋',
  messagePlaceholder: 'Type a message...',
  sendTitle: 'Send message',
  eventMessageNotification: 'An event was sent to you',
  newMessagePreviewFallback: 'New message',
  eventSharedPreview: 'Event shared',
  newMessagesIndicator: 'New messages',
  noConversationYet: 'No conversation yet',
  composerHint: 'Enter to send, Shift+Enter for a new line',
  sending: 'Sending…'
};

translations.de.footer = {
  discover: 'Entdecken',
  creators: 'Creator',
  legal: 'Rechtliches',
  social: 'Social',
  tagline: 'Mit ❤️ gemacht für Menschen, die Erlebnisse lieben',
  links: {
    about: 'Über uns',
    contact: 'Kontakt',
    careers: 'Karriere & Partnerschaften',
    events: 'Events',
    news: 'News & Reviews',
    buddies: 'Buddies',
    cities: 'Städte',
    artists: 'Artists',
    organizers: 'Veranstalter',
    venues: 'Venues',
    privacyPolicy: 'Datenschutz',
    terms: 'AGB',
    cookies: 'Cookies'
  }
};
translations.en.footer = {
  discover: 'Discover',
  creators: 'Creators',
  legal: 'Legal',
  social: 'Social',
  tagline: 'Made with ❤️ for people who love experiences',
  links: {
    about: 'About',
    contact: 'Contact',
    careers: 'Careers',
    events: 'Events',
    news: 'News & Reviews',
    buddies: 'Buddies',
    cities: 'Cities',
    artists: 'Artists',
    organizers: 'Organizers',
    venues: 'Venues',
    privacyPolicy: 'Privacy Policy',
    terms: 'Terms',
    cookies: 'Cookies'
  }
};

Object.assign(translations.de.common, { apply: 'Anwenden', on: 'An', off: 'Aus', confidence: { high: 'Hoch', medium: 'Mittel', low: 'Niedrig' } });
Object.assign(translations.en.common, { apply: 'Apply', on: 'On', off: 'Off', confidence: { high: 'High', medium: 'Medium', low: 'Low' } });

translations.de.drawer = { close: 'Schließen' };
translations.en.drawer = { close: 'Close' };

translations.de.imageUpload = {
  coverImage: 'Titelbild',
  authRequired: 'Du musst angemeldet sein, um ein Bild hochzuladen.',
  invalidType: 'Nicht unterstützter Dateityp. Nutze JPG, PNG, WEBP oder GIF.',
  tooLarge: 'Das Bild ist zu groß. Maximale Größe:',
  uploadFailed: 'Upload fehlgeschlagen. Bitte prüfe deine Verbindung und versuche es erneut.',
  urlFailed: 'Der Upload war erfolgreich, aber die Bild-URL konnte nicht geladen werden. Bitte versuche es erneut.',
  uploading: 'Wird hochgeladen…',
  previewBroken: 'Das Bild konnte nicht geladen werden. Wähle unten ein neues aus.',
  noCoverImage: 'Noch kein Titelbild',
  choosePhoto: 'Foto wählen',
  removeImage: 'Bild entfernen'
};
translations.en.imageUpload = {
  coverImage: 'Cover image',
  authRequired: 'You must be signed in to upload an image.',
  invalidType: 'Unsupported file type. Use JPG, PNG, WEBP, or GIF.',
  tooLarge: 'Image is too large. Max size is',
  uploadFailed: 'Upload failed. Please check your connection and try again.',
  urlFailed: 'Upload finished but the image URL could not be retrieved. Please try again.',
  uploading: 'Uploading…',
  previewBroken: 'Image could not be loaded. Choose a new one below.',
  noCoverImage: 'No cover image yet',
  choosePhoto: 'Choose photo',
  removeImage: 'Remove image'
};

translations.de.filters = {
  searchPlaceholder: 'Suchen…',
  noFilters: 'Keine Filter',
  removeTag: 'Entfernen',
  button: 'Filter',
  clear: 'Löschen',
  clearAll: 'Alle löschen',
  city: 'Stadt',
  from: 'Von',
  to: 'Bis',
  mood: 'Mood',
  genre: 'Genre',
  location: 'Standort',
  radius: 'Radius',
  locationReady: 'Standort bereit',
  locationPending: 'Standort ausstehend',
  groups: { music: 'Musik', workshops: 'Workshops' },
  options: {
    chill: 'Chill',
    party: 'Party',
    creative: 'Kreativ',
    romantic: 'Romantisch',
    adventure: 'Abenteuer',
    music: 'Musik',
    social: 'Social',
    networking: 'Networking',
    house: 'House',
    techno: 'Techno',
    hiphop: 'Hip-Hop',
    reggae: 'Reggae',
    pop: 'Pop',
    rock: 'Rock',
    jazz: 'Jazz',
    electronic: 'Electronic',
    drumbass: 'Drum & Bass',
    artworkshop: 'Kunst-Workshop',
    chillworkshop: 'Chill-Workshop',
    foodworkshop: 'Food-Workshop',
    creativeworkshop: 'Kreativ-Workshop'
  }
};
translations.en.filters = {
  searchPlaceholder: 'Search…',
  noFilters: 'No filters',
  removeTag: 'Remove',
  button: 'Filters',
  clear: 'Clear',
  clearAll: 'Clear all',
  city: 'City',
  from: 'From',
  to: 'To',
  mood: 'Mood',
  genre: 'Genre',
  location: 'Location',
  radius: 'Radius',
  locationReady: 'Location ready',
  locationPending: 'Location pending',
  groups: { music: 'Music', workshops: 'Workshops' },
  options: {
    chill: 'Chill',
    party: 'Party',
    creative: 'Creative',
    romantic: 'Romantic',
    adventure: 'Adventure',
    music: 'Music',
    social: 'Social',
    networking: 'Networking',
    house: 'House',
    techno: 'Techno',
    hiphop: 'Hip-Hop',
    reggae: 'Reggae',
    pop: 'Pop',
    rock: 'Rock',
    jazz: 'Jazz',
    electronic: 'Electronic',
    drumbass: 'Drum & Bass',
    artworkshop: 'Art Workshop',
    chillworkshop: 'Chill Workshop',
    foodworkshop: 'Food Workshop',
    creativeworkshop: 'Creative Workshop'
  }
};

Object.assign(translations.de.home, {
  tabPublic: 'Öffentlich',
  tabBuddies: 'Buddies',
  tabYours: 'Deins',
  tabDrafts: 'Entwürfe',
  status: { draft: 'ENTWURF', approved: 'FREIGEGEBEN', rejected: 'ABGELEHNT' },
  source: 'Quelle',
  reject: 'Ablehnen',
  approve: 'Freigeben',
  confidence: 'Confidence',
  postedOn: 'Gepostet',
  by: 'Von',
  emptyDrafts: 'Keine Entwürfe zur Prüfung.',
  emptyEntries: 'Hier gibt es noch keine Einträge.',
  drawerNews: 'Neue News',
  drawerReview: 'Neue Review',
  fieldTitle: 'Titel',
  fieldMoods: 'Moods',
  fieldGenres: 'Genres',
  fieldDescription: 'Beschreibung',
  fieldImage: 'Bild',
  aiAssistant: 'AI Assistant',
  cancel: 'Abbrechen',
  save: 'Speichern',
  update: 'Aktualisieren',
  close: 'Schließen',
  searching: 'Suche läuft…',
  findSuggestions: 'Vorschläge finden',
  saveAll: 'Alle als Entwürfe speichern',
  saveDraft: 'Als Entwurf speichern',
  mockNotice: 'Mock-Modus — noch keine Internet-Suche oder KI verbunden. Vorschläge werden nur als Entwürfe gespeichert und müssen vor der Veröffentlichung freigegeben werden.',
  pasteAtoms: 'Atoms-Ergebnisse (JSON) oder Text einfügen',
  pasteAtomsPlaceholder: 'Atoms-JSON einfügen, z. B. [{ "title": "…", "city": "…", "genres": [] }]',
  sourceType: 'Quelltyp',
  sourceTypeNews: 'News',
  sourceTypeReview: 'Review',
  sourceTypeEventIdea: 'Event-Idee',
  eventIdeaHint: 'Event-Ideen werden als markierte News-Entwürfe gespeichert.',
  genreEventType: 'Genre / Event-Typ',
  suggestions: 'Vorschläge',
  noSuggestions: 'Noch keine Vorschläge. Setze deine Filter und starte eine Suche.'
});
Object.assign(translations.en.home, {
  tabPublic: 'Public',
  tabBuddies: 'Buddies',
  tabYours: 'Yours',
  tabDrafts: 'Drafts',
  status: { draft: 'DRAFT', approved: 'APPROVED', rejected: 'REJECTED' },
  source: 'Source',
  reject: 'Reject',
  approve: 'Approve',
  confidence: 'Confidence',
  postedOn: 'Posted',
  by: 'By',
  emptyDrafts: 'No drafts awaiting review.',
  emptyEntries: 'No entries here yet.',
  drawerNews: 'New news',
  drawerReview: 'New review',
  fieldTitle: 'Title',
  fieldMoods: 'Moods',
  fieldGenres: 'Genres',
  fieldDescription: 'Description',
  fieldImage: 'Image',
  aiAssistant: 'AI Assistant',
  cancel: 'Cancel',
  save: 'Save',
  update: 'Update',
  close: 'Close',
  searching: 'Searching…',
  findSuggestions: 'Find suggestions',
  saveAll: 'Save all as drafts',
  saveDraft: 'Save as draft',
  mockNotice: 'Mock mode — no internet search or AI is connected yet. Suggestions are saved as drafts only and must be approved before they appear publicly.',
  pasteAtoms: 'Paste Atoms results (JSON) or text',
  pasteAtomsPlaceholder: 'Paste Atoms JSON, e.g. [{ "title": "…", "city": "…", "genres": [] }]',
  sourceType: 'Source type',
  sourceTypeNews: 'News',
  sourceTypeReview: 'Review',
  sourceTypeEventIdea: 'Event idea',
  eventIdeaHint: 'Event ideas are saved as News drafts, tagged.',
  genreEventType: 'Genre / event type',
  suggestions: 'suggestions',
  noSuggestions: 'No suggestions yet. Set your filters and run a search.'
});

Object.assign(translations.de.events, {
  assistant: 'Event Assistant',
  saveError: 'Das Event konnte nicht gespeichert werden. Bitte versuche es erneut.',
  confirmDelete: 'Möchtest du dieses Event wirklich löschen?',
  copySuffix: '(Kopie)',
  tabPublic: 'Öffentlich',
  tabBuddies: 'Buddies',
  tabOwn: 'Eigene',
  tabDrafts: 'Entwürfe',
  status: { draft: 'ENTWURF', approved: 'FREIGEGEBEN', rejected: 'ABGELEHNT' },
  source: 'Quelle',
  edit: 'Bearbeiten',
  reject: 'Ablehnen',
  approve: 'Freigeben',
  duplicate: 'Duplizieren',
  delete: 'Löschen',
  confidence: 'Confidence',
  postedOn: 'Gepostet',
  by: 'Von',
  cancel: 'Abbrechen',
  close: 'Schließen',
  searching: 'Suche läuft…',
  findSuggestions: 'Vorschläge finden',
  saveAll: 'Alle als Entwürfe speichern',
  saveDraft: 'Als Entwurf speichern',
  emptyDrafts: 'Keine Entwürfe zur Prüfung.',
  emptyEvents: 'Hier gibt es noch keine Events.',
  drawerEditTitle: 'Event bearbeiten',
  drawerNewTitle: 'Neues Event',
  fieldName: 'Name',
  fieldDate: 'Datum',
  fieldVenue: 'Venue / Ort',
  venuePlaceholder: 'Venue (optional)',
  fieldMoods: 'Moods',
  fieldGenres: 'Genres',
  fieldDescription: 'Beschreibung',
  descriptionPlaceholder: 'Beschreibung (optional)',
  coverImageHelp: 'Ein Titelbild wird empfohlen — Events mit Bild fallen mehr auf. (Optional)',
  imageUrlPlaceholder: '…oder eine Bild-URL einfügen',
  sourceUrlLabel: 'Quell-URL',
  sourceUrlPlaceholder: 'https://…',
  eventLocation: 'Event-Standort',
  useCurrentLocation: 'Aktuellen Standort übernehmen',
  locationSaved: 'Standort gespeichert',
  noEventLocation: 'Kein Event-Standort gesetzt',
  visibility: 'Sichtbarkeit',
  buddiesOnlyNotice: 'PartyBuddy-Nutzer können Events nur für Buddies veröffentlichen.',
  mockNotice: 'Mock-Modus — noch keine Internet-Suche oder KI verbunden. Vorschläge werden nur als Entwürfe gespeichert und müssen vor der Veröffentlichung freigegeben werden.',
  pasteAtoms: 'Atoms-Ergebnisse (JSON) oder Text einfügen',
  pasteAtomsPlaceholder: 'Atoms-JSON einfügen, z. B. [{ "name": "…", "city": "…", "date": "YYYY-MM-DD" }]',
  suggestions: 'Vorschläge',
  noSuggestions: 'Noch keine Vorschläge. Setze deine Filter und starte eine Suche.',
  countApproxHint: 'Ungefähr: basiert auf den bisher geladenen Ergebnissen (Freitextsuche/Standortumkreis kann nicht exakt serverseitig gezählt werden)',
  countExactHint: 'Exakte Gesamtanzahl vom Server'
});
Object.assign(translations.en.events, {
  assistant: 'Event Assistant',
  saveError: 'Could not save the event. Please try again.',
  confirmDelete: 'Do you really want to delete this event?',
  copySuffix: '(Copy)',
  tabPublic: 'Public',
  tabBuddies: 'Buddies',
  tabOwn: 'Own',
  tabDrafts: 'Drafts',
  status: { draft: 'DRAFT', approved: 'APPROVED', rejected: 'REJECTED' },
  source: 'Source',
  edit: 'Edit',
  reject: 'Reject',
  approve: 'Approve',
  duplicate: 'Duplicate',
  delete: 'Delete',
  confidence: 'Confidence',
  postedOn: 'Posted',
  by: 'By',
  cancel: 'Cancel',
  close: 'Close',
  searching: 'Searching…',
  findSuggestions: 'Find suggestions',
  saveAll: 'Save all as drafts',
  saveDraft: 'Save as draft',
  emptyDrafts: 'No drafts awaiting review.',
  emptyEvents: 'No events here yet.',
  drawerEditTitle: 'Edit event',
  drawerNewTitle: 'New event',
  fieldName: 'Name',
  fieldDate: 'Date',
  fieldVenue: 'Venue / location',
  venuePlaceholder: 'Venue (optional)',
  fieldMoods: 'Moods',
  fieldGenres: 'Genres',
  fieldDescription: 'Description',
  descriptionPlaceholder: 'Description (optional)',
  coverImageHelp: 'A cover image is recommended — events with a cover stand out. (Optional)',
  imageUrlPlaceholder: '…or paste an image URL',
  sourceUrlLabel: 'Source URL',
  sourceUrlPlaceholder: 'https://…',
  eventLocation: 'Event location',
  useCurrentLocation: 'Use current location',
  locationSaved: 'Location saved',
  noEventLocation: 'No event location set',
  visibility: 'Visibility',
  buddiesOnlyNotice: 'PartyBuddy users can publish events for buddies only.',
  mockNotice: 'Mock mode — no internet search or AI is connected yet. Suggestions are saved as drafts only and must be approved before they appear publicly.',
  pasteAtoms: 'Paste Atoms results (JSON) or text',
  pasteAtomsPlaceholder: 'Paste Atoms JSON, e.g. [{ "name": "…", "city": "…", "date": "YYYY-MM-DD" }]',
  suggestions: 'suggestions',
  noSuggestions: 'No suggestions yet. Set your filters and run a search.',
  countApproxHint: "Approximate: based on results loaded so far (free-text/location search can't be counted exactly server-side)",
  countExactHint: 'Exact total matching count from the server'
});

Object.assign(translations.de.event, {
  status: 'Status',
  confidence: 'Confidence',
  scoreReason: 'Score-Grund',
  priorityRegion: 'Prioritätsregion',
  notes: 'Notizen',
  importedBy: 'Importiert von'
});
Object.assign(translations.en.event, {
  status: 'Status',
  confidence: 'Confidence',
  scoreReason: 'Score reason',
  priorityRegion: 'Priority region',
  notes: 'Notes',
  importedBy: 'Imported by'
});

translations.de.about = {
  title: 'Über PartyBuddy',
  subtitle: 'Menschen durch gemeinsame Erlebnisse verbinden',
  storyTitle: 'Unsere Story',
  storyParagraph1: 'PartyBuddy entstand aus einer einfachen Beobachtung: Tolle Events passieren ständig, aber die richtigen Menschen zu finden, um sie gemeinsam zu erleben, ist oft schwieriger als nötig.',
  storyParagraph2: 'Wir glauben, dass die besten Erinnerungen aus spontanen Momenten und echten Verbindungen entstehen. Ob Live-Konzert, Festival, Clubnacht oder Kultur-Event — du solltest nur dann allein gehen, wenn du das wirklich willst.',
  visionTitle: 'Unsere Vision',
  visionParagraph1: 'Wir stellen uns eine Welt vor, in der Events entdecken und die perfekte Party-Crew finden so einfach ist wie ein paar Taps. PartyBuddy baut die soziale Ebene rund um Events — Communities rund um gemeinsame Interessen und unvergessliche Erlebnisse.',
  visionParagraph2: 'Indem wir Artists, Veranstalter, Venues und Besucher verbinden, machen wir das Event-Ökosystem transparenter, inklusiver und spannender.',
  todayTitle: 'Wo wir heute stehen',
  todayParagraph1: 'PartyBuddy steckt noch in einer frühen Phase — wir sind ein kleines Team, das die Plattform offen aufbaut und weiter verfeinert. Kernfunktionen wie Event-Discovery, Buddy-Matching und News & Reviews sind schon live, und mehr folgt, während wir auf frühes Feedback hören.',
  todayParagraph2Prefix: 'Das bedeutet auch, dass du hier und da noch Ecken und Kanten entdecken könntest. Wenn dir etwas auffällt, freuen wir uns wirklich darüber — schau auf unsere',
  contactLink: 'Kontakt',
  todayParagraph2Suffix: 'Seite.',
  beliefsTitle: 'Woran wir glauben',
  beliefs: {
    authenticity: { label: 'Authentizität:', text: 'Echte Menschen, echte Events, echte Verbindungen' },
    inclusivity: { label: 'Inklusivität:', text: 'Events sind für alle da. Alle Genres, alle Vibes, alle willkommen' },
    community: { label: 'Community:', text: 'Wir bauen für Creator, Veranstalter und Besucher gleichermaßen' },
    experience: { label: 'Erlebnis:', text: 'Wir feiern die Momente, die zählen — die, an die du dich für immer erinnerst' }
  },
  closingTitle: 'Mit ❤️ gemacht für Menschen, die Erlebnisse lieben',
  closingText: 'Jede Funktion, die wir bauen, und jede Entscheidung, die wir treffen, dient einem Ziel: dir dabei zu helfen, deine Leute zu finden und Erinnerungen zu schaffen, die sich lohnen.'
};
translations.en.about = {
  title: 'About PartyBuddy', subtitle: 'Connecting people through shared experiences', storyTitle: 'Our Story',
  storyParagraph1: 'PartyBuddy was born from a simple observation: amazing events happen all the time, but finding the right people to experience them with is harder than it should be.',
  storyParagraph2: "We believe that the best memories come from spontaneous moments and genuine connections. Whether it's a live concert, festival, club night, or cultural event, you shouldn't have to go alone unless you want to.",
  visionTitle: 'Our Vision',
  visionParagraph1: 'We envision a world where discovering events and finding your perfect party crew is as easy as a few taps. PartyBuddy is building the social layer for events—creating communities around shared interests and unforgettable experiences.',
  visionParagraph2: "By connecting artists, organizers, venues, and attendees, we're making the event ecosystem more transparent, inclusive, and fun.",
  todayTitle: 'Where We Are Today',
  todayParagraph1: "PartyBuddy is still early — we're a small team building and refining the platform in the open. Core features like event discovery, buddy matching, and news & reviews are live today, with more on the way as we listen to early users.",
  todayParagraph2Prefix: "That means you might spot rough edges here and there. If you do, we'd genuinely love to hear about it — see our",
  contactLink: 'Contact',
  todayParagraph2Suffix: 'page.',
  beliefsTitle: 'What We Believe In',
  beliefs: {
    authenticity: { label: 'Authenticity:', text: 'Real people, real events, real connections' },
    inclusivity: { label: 'Inclusivity:', text: 'Events are for everyone. All genres, all vibes, all welcome' },
    community: { label: 'Community:', text: "We're building for creators, organizers, and attendees alike" },
    experience: { label: 'Experience:', text: "We celebrate the moments that matter—the ones you'll remember forever" }
  },
  closingTitle: 'Made with ❤️ for people who love experiences',
  closingText: 'Every feature we build, every decision we make, is in service of one goal: helping you find your people and create memories worth having.'
};

translations.de.contact = {
  title: 'Melde dich bei uns', subtitle: 'Wir freuen uns, von dir zu hören', methodsTitle: 'Kontaktmöglichkeiten',
  emailTitle: 'E-Mail', emailText: 'Allgemeine Anfragen, Feedback und Partnerschaftsmöglichkeiten',
  instagramText: 'Neueste Events, Community-Highlights und Einblicke hinter die Kulissen',
  facebookText: 'Event-Diskussionen und Community-Updates',
  businessTitle: 'Business-Anfragen', businessText: 'Partnerschaften, Sponsorings und Enterprise-Lösungen',
  responseTitle: 'Durchschnittliche Antwortzeit',
  responseText: 'Wir antworten in der Regel innerhalb von 24–48 Stunden. In dringenden Fällen erreichst du uns am besten über Instagram oder Facebook.'
};
translations.en.contact = {
  title: 'Get in Touch', subtitle: "We'd love to hear from you", methodsTitle: 'Contact Methods',
  emailTitle: 'Email', emailText: 'General inquiries, feedback, and partnership opportunities',
  instagramText: 'Latest events, community highlights, and behind-the-scenes',
  facebookText: 'Event discussions and community updates',
  businessTitle: 'Business Inquiries', businessText: 'Partnerships, sponsorships, and enterprise solutions',
  responseTitle: 'Average Response Time',
  responseText: 'We typically respond to inquiries within 24-48 hours. For urgent matters, please reach out via Instagram or Facebook.'
};

translations.de.careers = {
  title: 'Karriere & Partnerschaften', subtitle: 'Baue mit uns etwas Großartiges',
  hiringTitle: 'Wir stellen noch nicht ein',
  hiringText: 'PartyBuddy ist noch in einer frühen Phase und wir sind aktuell ein kleines, fokussiertes Team. Trotzdem hören wir immer gerne von leidenschaftlichen Menschen, die mit uns die Zukunft der Event-Discovery bauen wollen.',
  developersTitle: 'Für Entwickler', developersText1: 'Du bist Entwickler und findest spannend, woran wir arbeiten? Wir freuen uns auf deine Ideen zu Features, Integrationen oder dazu, wie PartyBuddy in deine Projekte passen könnte.', developersText2: 'Schreib uns an:',
  partnersTitle: 'Für Partner', partnersText: 'Wir interessieren uns für strategische Partnerschaften mit Venues, Event-Promotern, Festivals und Plattformen, die unsere Vision teilen, Menschen über Erlebnisse zu verbinden.',
  journeyTitle: 'Begleite unsere Reise', journeyText: 'Du möchtest wissen, woran wir bauen? Folge uns auf Social Media oder abonniere unsere Updates, um früh zu erfahren, wenn wir nach Talenten und Partnerschaften suchen.'
};
translations.en.careers = {
  title: 'Careers & Partnerships', subtitle: 'Build something amazing with us', hiringTitle: "We're Not Hiring Yet",
  hiringText: "PartyBuddy is in early stages and we're currently a small, focused team. However, we're always interested in hearing from passionate people who want to help us build the future of event discovery.",
  developersTitle: 'For Developers', developersText1: "Are you a developer interested in what we're building? We'd love to hear about your ideas for features, integrations, or how PartyBuddy could fit into your projects.", developersText2: 'Reach out to us at:',
  partnersTitle: 'For Partners', partnersText: "We're interested in strategic partnerships with venues, event promoters, festivals, and platforms that share our vision of connecting people through experiences.",
  journeyTitle: 'Follow Our Journey', journeyText: "Want to stay updated on what we're building? Follow us on social media or subscribe to our updates to be among the first to know when we're looking for talent and partnerships."
};

translations.de.cities = {
  title: 'Events nach Stadt entdecken', subtitle: 'Demnächst verfügbar', comingSoonTitle: 'Stadt-Guides kommen bald',
  comingSoonText: 'Wir bauen gerade eigene Stadt-Guides, damit du die besten Events in deiner Umgebung leichter entdecken kannst.',
  soonText: 'Schon bald kannst du entdecken:', followText: 'Schau bald wieder vorbei oder folge uns auf Social Media für Updates!',
  items: { localEventHubs: '📍 Lokale Event-Hubs', musicVenues: '🎵 Musik-Venues', cultureArts: '🎭 Kultur & Kunst', nightlife: '🎉 Nightlife' }
};
translations.en.cities = {
  title: 'Browse Events by City', subtitle: 'Coming Soon', comingSoonTitle: 'City Guides Coming Soon',
  comingSoonText: "We're currently building dedicated city guides to help you discover the best events happening in your area.",
  soonText: "Soon you'll be able to explore:", followText: 'Check back soon or follow our social media for updates!',
  items: { localEventHubs: '📍 Local Event Hubs', musicVenues: '🎵 Music Venues', cultureArts: '🎭 Culture & Arts', nightlife: '🎉 Nightlife' }
};

translations.de.artists = {
  title: 'Artist-Accounts', subtitle: 'Baue deine Fanbase auf und promote deine Musik', accountTitle: '🎤 Was ist ein Artist-Account?',
  accountText: 'Ein Artist-Account bei PartyBuddy ist dein direkter Weg, um Fans zu erreichen, kommende Auftritte zu promoten und deine Community aufzubauen.',
  featuresTitle: 'Was kannst du tun?',
  features: {
    showcase: { label: 'Deine Gigs zeigen:', text: 'Promote deine kommenden Auftritte und erreiche neue Fans' },
    following: { label: 'Deine Followerschaft aufbauen:', text: 'Verbinde dich mit Menschen, die deine Musik lieben' },
    community: { label: 'Deine Community einbinden:', text: 'Teile Updates, Behind-the-Scenes-Content und exklusive Infos' },
    tickets: { label: 'Tickets verkaufen:', text: 'Integrierter Ticketverkauf für deine Events' },
    analytics: { label: 'Analytics:', text: 'Verfolge das Interesse an deinen Auftritten und erweitere dein Publikum' }
  },
  gettingStartedTitle: 'Erste Schritte',
  gettingStartedText1: 'Die Artist-Verifizierung kommt bald. Sobald sie verfügbar ist, erhalten verifizierte Artists exklusive Promotion-Tools und Analytics.',
  gettingStartedText2: 'Du willst Artist-Partner werden? Kontaktiere uns unter'
};
translations.en.artists = {
  title: 'Artist Accounts', subtitle: 'Grow your fanbase and promote your music', accountTitle: '🎤 What is an Artist Account?',
  accountText: 'An Artist Account on PartyBuddy is your gateway to connect directly with fans, promote upcoming performances, and build your community.',
  featuresTitle: 'What Can You Do?',
  features: {
    showcase: { label: 'Showcase Your Gigs:', text: 'Promote your upcoming performances and reach new fans' },
    following: { label: 'Build Your Following:', text: 'Connect with people who love your music' },
    community: { label: 'Engage Your Community:', text: 'Share updates, behind-the-scenes content, and exclusive info' },
    tickets: { label: 'Sell Tickets:', text: 'Integrated ticket sales for your events' },
    analytics: { label: 'Analytics:', text: 'Track interest in your performances and grow your audience' }
  },
  gettingStartedTitle: 'Getting Started',
  gettingStartedText1: 'Artist verification is coming soon. Once available, verified artists will unlock exclusive promotion tools and analytics.',
  gettingStartedText2: 'Interested in becoming an artist partner? Contact us at'
};

translations.de.organizers = {
  title: 'Veranstalter-Accounts', subtitle: 'Verwalte Events, baue deine Community aus und maximiere Reichweite', accountTitle: '🎯 Was ist ein Veranstalter-Account?',
  accountText: 'Ein Veranstalter-Account ist für Promoter, Event-Agenturen und Festivalveranstalter gedacht, die Events direkt für die PartyBuddy-Community erstellen, verwalten und promoten möchten.',
  featuresTitle: 'Event-Management-Funktionen',
  features: {
    createManage: { label: 'Events erstellen & verwalten:', text: 'Veröffentliche detaillierte Event-Infos mit Bildern, Beschreibungen und Ticketdetails' },
    reach: { label: 'Neue Zielgruppen erreichen:', text: 'Bringe deine Events vor engagierte Event-Sucher' },
    ticketing: { label: 'Integriertes Ticketing:', text: 'Verkaufe Tickets direkt oder verlinke externe Plattformen' },
    community: { label: 'Community-Building:', text: 'Bleibe vor, während und nach dem Event mit Besuchern in Kontakt' },
    analytics: { label: 'Performance-Analytics:', text: 'Verfolge Attendance, Interesse und Publikumswachstum' }
  },
  perfectForTitle: 'Perfekt für',
  perfectFor: { festival: '🎭 Festivalveranstalter und Event-Reihen', music: '🎵 Musik-Promoter und Booking-Agenturen', entertainment: '🎪 Entertainment-Unternehmen', party: '🎉 Party- und Club-Promoter', cultural: '🎨 Kulturveranstalter' },
  becomeTitle: 'Veranstalter werden',
  becomeText1: 'Die Veranstalter-Verifizierung befindet sich aktuell in der Beta. Partner erhalten Zugriff auf erweiterte Promotion-Tools und Analytics.',
  becomeText2: 'Du willst deine Events auf PartyBuddy wachsen lassen? Schreib uns an'
};
translations.en.organizers = {
  title: 'Organizer Accounts', subtitle: 'Manage events, grow your community, and maximize attendance', accountTitle: '🎯 What is an Organizer Account?',
  accountText: 'An Organizer Account is designed for promoters, event agencies, and festival organizers to create, manage, and promote events directly to the PartyBuddy community.',
  featuresTitle: 'Event Management Features',
  features: {
    createManage: { label: 'Create & Manage Events:', text: 'Post detailed event information with images, descriptions, and ticketing details' },
    reach: { label: 'Reach New Audiences:', text: 'Get your events in front of engaged event-seekers' },
    ticketing: { label: 'Integrated Ticketing:', text: 'Sell tickets directly or link to external platforms' },
    community: { label: 'Community Building:', text: 'Engage attendees before, during, and after events' },
    analytics: { label: 'Performance Analytics:', text: 'Track attendance, interest trends, and audience growth' }
  },
  perfectForTitle: 'Perfect For',
  perfectFor: { festival: '🎭 Festival organizers and event series', music: '🎵 Music promoters and booking agencies', entertainment: '🎪 Entertainment companies', party: '🎉 Party and club promoters', cultural: '🎨 Cultural event organizers' },
  becomeTitle: 'Become an Organizer',
  becomeText1: 'Organizer verification is currently in beta. Partners get access to advanced promotion tools and analytics.',
  becomeText2: 'Want to grow your events on PartyBuddy? Reach out to'
};

translations.de.venues = {
  title: 'Venue-Accounts', subtitle: 'Zeige deinen Space, verwalte Buchungen und vergrößere dein Publikum', accountTitle: '🏢 Was ist ein Venue-Account?',
  accountText: 'Mit einem Venue-Account können Clubs, Bars, Konzerthallen, Studios und Event-Locations ihre Events verwalten, kommende Shows promoten und sich mit Besuchern auf PartyBuddy verbinden.',
  toolsTitle: 'Venue-Management-Tools',
  tools: {
    listings: { label: 'Event-Listings:', text: 'Erstelle und verwalte alle Events in deiner Venue' },
    profile: { label: 'Venue-Profil:', text: 'Zeige deinen Space mit Fotos, Kapazitätsinfos und Ausstattung' },
    connections: { label: 'Promoter-Verbindungen:', text: 'Verbinde dich mit Promotern und Artists, die deine Venue buchen' },
    insights: { label: 'Audience-Insights:', text: 'Verstehe dein Publikum und plane künftige Events besser' },
    ticketing: { label: 'Ticketing-Integration:', text: 'Verkaufe Tickets direkt oder über Partnerplattformen' }
  },
  typesTitle: 'Arten von Venues',
  types: { concert: '🎵 Konzertlocations und Musikclubs', bars: '🍺 Bars, Pubs und Lounges', theaters: '🎭 Theater und Performing-Arts-Spaces', nightclubs: '🎪 Nightclubs und Tanz-Locations', galleries: '🎨 Galerien und kreative Räume', comedy: '🎤 Comedy-Clubs und Stand-up-Locations', sports: '🏟️ Sportsbars und Event-Spaces' },
  listTitle: 'Deine Venue listen', listText1: 'Venue-Partnerschaften sind aktuell in Entwicklung. Interessierte Venues können früh Zugriff auf die Plattform erhalten und die Zukunft der Venue-Promotion auf PartyBuddy mitgestalten.', listText2Prefix: 'Kontaktiere uns unter', listText2Suffix: 'um mehr zu erfahren.'
};
translations.en.venues = {
  title: 'Venue Accounts', subtitle: 'Showcase your space, manage bookings, and grow your audience', accountTitle: '🏢 What is a Venue Account?',
  accountText: 'A Venue Account allows clubs, bars, concert halls, studios, and event spaces to manage their events, promote upcoming shows, and connect with attendees on PartyBuddy.',
  toolsTitle: 'Venue Management Tools',
  tools: {
    listings: { label: 'Event Listings:', text: 'Create and manage all events happening at your venue' },
    profile: { label: 'Venue Profile:', text: 'Showcase your space with photos, capacity info, and amenities' },
    connections: { label: 'Promoter Connections:', text: 'Connect with promoters and artists booking your space' },
    insights: { label: 'Audience Insights:', text: 'Understand your attendees and plan future events' },
    ticketing: { label: 'Ticketing Integration:', text: 'Sell tickets directly or through partner platforms' }
  },
  typesTitle: 'Types of Venues',
  types: { concert: '🎵 Concert venues and music clubs', bars: '🍺 Bars, pubs, and lounges', theaters: '🎭 Theaters and performing arts spaces', nightclubs: '🎪 Nightclubs and dance venues', galleries: '🎨 Art galleries and creative spaces', comedy: '🎤 Comedy clubs and stand-up venues', sports: '🏟️ Sports bars and event spaces' },
  listTitle: 'List Your Venue', listText1: 'Venue partnerships are currently in development. Interested venues can early-access the platform and help shape the future of venue promotion on PartyBuddy.', listText2Prefix: 'Contact us at', listText2Suffix: 'to learn more.'
};

translations.de.privacyPage = {
  title: 'Datenschutzerklärung', subtitle: 'Zuletzt aktualisiert: Juli 2026', introductionTitle: 'Einleitung',
  introductionText: 'PartyBuddy ("wir", "uns", "unser" oder "Unternehmen") verpflichtet sich, deine Privatsphäre zu schützen. Diese Datenschutzerklärung erklärt, wie wir deine Informationen erfassen, verwenden, offenlegen und schützen, wenn du unsere Plattform besuchst.',
  collectTitle: 'Welche Informationen wir sammeln', collectIntro: 'Wir sammeln Informationen auf folgende Weise:',
  collect: {
    account: { label: 'Kontoinformationen:', text: 'Dein Name, deine E-Mail-Adresse, Telefonnummer, Profilbild und Präferenzen' },
    usage: { label: 'Nutzungsdaten:', text: 'Informationen darüber, wie du mit unserer Plattform interagierst' },
    location: { label: 'Standortdaten:', text: 'Informationen über deinen Standort (mit deiner Zustimmung)' },
    device: { label: 'Geräteinformationen:', text: 'Informationen über das Gerät, mit dem du auf PartyBuddy zugreifst' }
  },
  useTitle: 'Wie wir deine Informationen verwenden',
  use: { services: 'Um unsere Services bereitzustellen und zu betreiben', improve: 'Um die Nutzererfahrung zu verbessern und neue Funktionen zu entwickeln', updates: 'Um dir Updates und Werbeinhalte zu senden (mit Zustimmung)', security: 'Um Betrug oder Sicherheitsprobleme zu erkennen und zu verhindern' },
  securityTitle: 'Datensicherheit', securityText: 'Wir setzen angemessene Sicherheitsmaßnahmen ein, um deine persönlichen Daten zu schützen. Allerdings ist keine Übertragung im Internet vollständig sicher. Wir können keine absolute Sicherheit garantieren, setzen aber alles daran, deine Daten zu schützen.',
  rightsTitle: 'Deine Rechte', rightsIntro: 'Du hast das Recht:',
  rights: { access: 'Auf deine persönlichen Informationen zuzugreifen', correction: 'Die Korrektur ungenauer Daten zu verlangen', deletion: 'Die Löschung deiner Daten zu verlangen', marketing: 'Marketing-Kommunikation abzulehnen' },
  contactTitle: 'Kontakt', contactText: 'Wenn du Fragen zu dieser Datenschutzerklärung hast, kontaktiere uns bitte unter'
};
translations.en.privacyPage = {
  title: 'Privacy Policy', subtitle: 'Last updated: July 2026', introductionTitle: 'Introduction',
  introductionText: 'PartyBuddy ("we," "us," "our," or "Company") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our platform.',
  collectTitle: 'Information We Collect', collectIntro: 'We collect information in the following ways:',
  collect: {
    account: { label: 'Account Information:', text: 'Your name, email, phone number, profile picture, and preferences' },
    usage: { label: 'Usage Data:', text: 'Information about how you interact with our platform' },
    location: { label: 'Location Data:', text: 'Information about your location (with your consent)' },
    device: { label: 'Device Information:', text: 'Information about the device you use to access PartyBuddy' }
  },
  useTitle: 'How We Use Your Information',
  use: { services: 'To provide and maintain our services', improve: 'To improve user experience and develop new features', updates: 'To send you updates and promotional content (with consent)', security: 'To detect and prevent fraud or security issues' },
  securityTitle: 'Data Security', securityText: 'We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet is entirely secure. We cannot guarantee absolute security but are committed to protecting your data.',
  rightsTitle: 'Your Rights', rightsIntro: 'You have the right to:',
  rights: { access: 'Access your personal information', correction: 'Request correction of inaccurate data', deletion: 'Request deletion of your data', marketing: 'Opt-out of marketing communications' },
  contactTitle: 'Contact Us', contactText: 'If you have questions about this Privacy Policy, please contact us at'
};

translations.de.termsPage = {
  title: 'Nutzungsbedingungen', subtitle: 'Zuletzt aktualisiert: Juli 2026', agreementTitle: 'Zustimmung zu den Bedingungen',
  agreementText: 'Durch den Zugriff auf PartyBuddy und die Nutzung von PartyBuddy akzeptierst du diese Vereinbarung und erklärst dich an ihre Bestimmungen gebunden. Wenn du damit nicht einverstanden bist, nutze diesen Service bitte nicht.',
  licenseTitle: 'Nutzungslizenz', licenseText1: 'Es wird die Erlaubnis erteilt, eine Kopie der Materialien (Informationen oder Software) auf PartyBuddy vorübergehend für die persönliche, nicht-kommerzielle Ansicht herunterzuladen. Dies ist die Gewährung einer Lizenz, keine Übertragung des Eigentums.', licenseText2: 'Im Rahmen dieser Lizenz darfst du nicht:',
  license: { modify: 'Die Materialien verändern oder kopieren', commercial: 'Die Materialien für kommerzielle Zwecke oder öffentliche Darstellung verwenden', reverseEngineer: 'Versuchen, auf PartyBuddy enthaltene Software zu dekompilieren oder zurückzuentwickeln', copyright: 'Urheberrechts- oder sonstige Eigentumshinweise entfernen', transfer: 'Die Materialien an andere Personen übertragen oder gespiegelt weitergeben' },
  conductTitle: 'Nutzerverhalten', conductIntro: 'Du erklärst dich damit einverstanden, nicht:',
  conduct: { harass: 'Einzelpersonen oder Gruppen zu belästigen, bedrohen, verleumden oder missbrauchen', falseInfo: 'Falsche oder irreführende Informationen zu posten', laws: 'Gegen Gesetze oder Vorschriften zu verstoßen', spam: 'Zu spammen, Phishing zu betreiben oder unbefugten Zugriff zu versuchen', ip: 'Rechte an geistigem Eigentum zu verletzen' },
  ownershipTitle: 'Eigentum an Inhalten', ownershipText: 'Du behältst alle Rechte an Inhalten, die du auf PartyBuddy veröffentlichst. Durch das Posten gewährst du PartyBuddy eine weltweite, nicht-exklusive Lizenz, deine Inhalte für den Betrieb der Plattform anzuzeigen und zu verbreiten.',
  disclaimerTitle: 'Haftungsausschluss', disclaimerText: 'Die Materialien auf PartyBuddy werden "wie besehen" bereitgestellt. PartyBuddy übernimmt keine ausdrücklichen oder stillschweigenden Garantien und schließt insbesondere Garantien der Marktgängigkeit, Eignung für einen bestimmten Zweck oder Nichtverletzung von Rechten aus.',
  liabilityTitle: 'Haftungsbeschränkung', liabilityText: 'In keinem Fall haften PartyBuddy oder seine Lieferanten für Schäden (einschließlich, aber nicht beschränkt auf Datenverlust, entgangenen Gewinn oder Geschäftsunterbrechung), die aus der Nutzung oder Unmöglichkeit der Nutzung der Materialien auf PartyBuddy entstehen.',
  modificationsTitle: 'Änderungen', modificationsText: 'PartyBuddy kann diese Bedingungen jederzeit ohne Vorankündigung überarbeiten. Durch die Nutzung der Plattform erklärst du dich mit der jeweils aktuellen Version dieser Bedingungen einverstanden.',
  contactTitle: 'Kontakt', contactText: 'Wenn du Fragen zu diesen Nutzungsbedingungen hast, kontaktiere uns bitte unter'
};
translations.en.termsPage = {
  title: 'Terms of Service', subtitle: 'Last updated: July 2026', agreementTitle: 'Agreement to Terms',
  agreementText: 'By accessing and using PartyBuddy, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.',
  licenseTitle: 'Use License', licenseText1: 'Permission is granted to temporarily download one copy of the materials (information or software) on PartyBuddy for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.', licenseText2: 'Under this license you may not:',
  license: { modify: 'Modify or copy the materials', commercial: 'Use the materials for any commercial purpose or for any public display', reverseEngineer: 'Attempt to decompile or reverse engineer any software contained on PartyBuddy', copyright: 'Remove any copyright or other proprietary notations', transfer: 'Transfer the materials to another person or mirror the materials' },
  conductTitle: 'User Conduct', conductIntro: 'You agree not to:',
  conduct: { harass: 'Harass, threaten, defame, or abuse any person or group', falseInfo: 'Post false or misleading information', laws: 'Violate any laws or regulations', spam: 'Spam, phish, or attempt to gain unauthorized access', ip: 'Infringe on intellectual property rights' },
  ownershipTitle: 'Content Ownership', ownershipText: 'You retain all rights to content you post on PartyBuddy. By posting content, you grant PartyBuddy a worldwide, non-exclusive license to display and distribute your content for the purpose of the platform.',
  disclaimerTitle: 'Disclaimer', disclaimerText: "The materials on PartyBuddy are provided on an 'as is' basis. PartyBuddy makes no warranties, expressed or implied, and hereby disclaims all other warranties, including implied warranties of merchantability, fitness for a particular purpose, or non-infringement.",
  liabilityTitle: 'Limitation of Liability', liabilityText: 'In no event shall PartyBuddy or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on PartyBuddy.',
  modificationsTitle: 'Modifications', modificationsText: 'PartyBuddy may revise these terms at any time without notice. By using this platform, you are agreeing to be bound by the then current version of these terms.',
  contactTitle: 'Contact', contactText: 'If you have questions about these Terms of Service, please contact us at'
};

translations.de.cookiesPage = {
  title: 'Cookie-Richtlinie', subtitle: 'Zuletzt aktualisiert: Juli 2026', whatTitle: 'Was sind Cookies?',
  whatText: 'Cookies sind kleine Dateien auf deinem Gerät, die uns helfen, dich zu erkennen und dir ein besseres Erlebnis zu bieten. Sie sind eine Standard-Webtechnologie, die auf fast allen Websites verwendet wird.',
  typesTitle: 'Arten von Cookies, die wir verwenden',
  essentialTitle: 'Essenzielle Cookies', essentialText: 'Erforderlich, damit die Plattform funktioniert. Dazu gehören Authentifizierungs-Tokens, Spracheinstellungen und Sitzungsinformationen. Diese Cookies können nicht deaktiviert werden.',
  performanceTitle: 'Performance-Cookies', performanceText: 'Helfen uns zu verstehen, wie Nutzer mit PartyBuddy interagieren. Sie erfassen Seitenaufrufe, Nutzerverhalten und Performance-Metriken, damit wir unseren Service verbessern können.',
  preferenceTitle: 'Präferenz-Cookies', preferenceText: 'Merken sich deine Einstellungen und Präferenzen, zum Beispiel die Sprachwahl, Theme-Entscheidungen und gespeicherte Filter.',
  marketingTitle: 'Marketing-Cookies', marketingText: 'Werden verwendet, um relevante Werbung auszuspielen und die Wirksamkeit von Kampagnen zu messen (mit deiner Zustimmung).',
  thirdPartyTitle: 'Cookies von Drittanbietern', thirdPartyText: 'Wir können Drittanbietern (z. B. Analytics-Anbietern oder Werbenetzwerken) erlauben, Cookies auf deinem Gerät zu platzieren. Diese unterliegen deren eigenen Datenschutzrichtlinien.',
  choicesTitle: 'Deine Cookie-Auswahl', choicesIntro: 'Du kannst Cookies auf verschiedene Weise steuern:',
  choices: {
    browser: { label: 'Browser-Einstellungen:', text: 'Die meisten Browser erlauben es dir, Cookies abzulehnen oder dich zu warnen, wenn welche gesendet werden' },
    preferences: { label: 'Cookie-Einstellungen:', text: 'Möglicherweise kannst du Cookie-Präferenzen über unsere Einstellungen verwalten' },
    optOut: { label: 'Opt-out:', text: 'Du kannst Marketing-Cookies deaktivieren, ohne die Funktionalität der Plattform zu beeinträchtigen' }
  },
  noteTitle: 'Wichtiger Hinweis', noteText: 'Wenn du essenzielle Cookies deaktivierst, funktioniert PartyBuddy möglicherweise nicht korrekt. Du kannst die Website weiterhin nutzen, dein Erlebnis kann aber eingeschränkt sein.',
  changesTitle: 'Änderungen an dieser Richtlinie', changesText: 'Wir können diese Cookie-Richtlinie gelegentlich aktualisieren. Über Änderungen informieren wir dich, indem wir das Datum "Zuletzt aktualisiert" am Seitenanfang anpassen.',
  questionsTitle: 'Fragen?', questionsText: 'Wenn du Fragen zu unserem Einsatz von Cookies hast, kontaktiere uns bitte unter'
};
translations.en.cookiesPage = {
  title: 'Cookie Policy', subtitle: 'Last updated: July 2026', whatTitle: 'What Are Cookies?',
  whatText: "Cookies are small files stored on your device that help us recognize you and provide a better experience. They're a standard web technology used by virtually all websites.",
  typesTitle: 'Types of Cookies We Use',
  essentialTitle: 'Essential Cookies', essentialText: 'Required for the platform to function. These include authentication tokens, language preferences, and session information. These cookies cannot be disabled.',
  performanceTitle: 'Performance Cookies', performanceText: 'Help us understand how users interact with PartyBuddy. They track page views, user engagement, and performance metrics to improve our service.',
  preferenceTitle: 'Preference Cookies', preferenceText: 'Remember your settings and preferences, such as language selection, theme choices, and saved filters.',
  marketingTitle: 'Marketing Cookies', marketingText: 'Used to deliver relevant advertisements and track campaign effectiveness (with your consent).',
  thirdPartyTitle: 'Third-Party Cookies', thirdPartyText: 'We may allow third parties (such as analytics providers and advertising networks) to place cookies on your device. These are governed by their own privacy policies.',
  choicesTitle: 'Your Cookie Choices', choicesIntro: 'You can control cookies in several ways:',
  choices: {
    browser: { label: 'Browser Settings:', text: "Most browsers allow you to refuse cookies or alert you when they're being sent" },
    preferences: { label: 'Cookie Preferences:', text: 'You may be able to manage cookie preferences through our settings' },
    optOut: { label: 'Opt-Out:', text: 'You can opt out of marketing cookies without affecting platform functionality' }
  },
  noteTitle: 'Important Note', noteText: "Disabling essential cookies may prevent PartyBuddy from functioning properly. You'll still be able to use the site, but your experience may be limited.",
  changesTitle: 'Changes to This Policy', changesText: `We may update this Cookie Policy from time to time. We'll notify you of any changes by updating the "Last updated" date at the top of this page.`,
  questionsTitle: 'Questions?', questionsText: 'For questions about our use of cookies, please contact us at'
};

export const defaultLanguage = 'de';
